export { default as PartnerPreviewCard } from './PartnerPreviewCard';
export type { PartnerPreviewCardProps } from './PartnerPreviewCard';
